

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const IS_DEV = false; // Set to true for development, false for production

export const DOCUMENT_ID = 590584
export const REACT_APP_TYPE_COMPTE_PARTICULIER_ID = 699914

// 704376
export const AUTHORIZATION_HEADER2 = 'mori@gmail.com:m'
// export const AUTHORIZATION_HEADER1 =  'jacobcrobs035@gmail.com:Bicici123'
export const AUTHORIZATION_HEADER1 = 'smsagnon@gmail.com:azaz'

export const API_HEADERS = IS_DEV
    ? {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + btoa(AUTHORIZATION_HEADER2)
    }
    : {
        'Content-Type': 'application/json',
        'x-csrf-token': window.Liferay.authToken,
    }


export const API_FILES_HEADERS = IS_DEV
    ? {
        Authorization: "Basic " + btoa(AUTHORIZATION_HEADER2),
        Accept: "application/json",
    }
    : {
        Accept: "application/json",
        "x-csrf-token": window.Liferay.authToken,
    }



export const liferayConfig = IS_DEV
    ? {
        authToken: "Basic " + btoa(AUTHORIZATION_HEADER2),
        groupId: 473613,
        companyId: 0,
        baseUrl: "https://lab.diginfactory.com",
    }

    : {
        authToken: window.Liferay.authToken,
        groupId: window?.Liferay?.ThemeDisplay.getScopeGroupId(),
        companyId: 0,
        baseUrl: window?.Liferay?.ThemeDisplay.getPortalURL()
    }


export const formatDate = (date) => {
    return new Date(date).toLocaleString(
        "fr-FR",
        {
            timeZone: "UTC",
            month: "numeric",
            day: "numeric",
            year: "numeric"
        }
    )
} 